<template>
  <div>
    <div class="modal-backdrop fade show"></div>

    <div
      class="modal fade show modal-dialog-centered modal-dialog-scrollable"
      style="padding-right: 12px; display: block;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isAdd ? 'Новый диагноз' : 'Редактирование' }}.
            </h5>

            <button type="button" class="close" @click="$emit('cancel')">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="modal-body">
            <form>
              <div class="form-group">
                <label>Диагноз</label>
                <Select
                  v-if="isAdd"
                  :data="data"
                  placeholder="Выбирете"
                  v-model="diagnosis"/>

                <input
                  v-else
                  class="form-control"
                  type="text"
                  :value="diagnosisTitle"
                  disabled/>
              </div>

              <div class="form-group">
                <label>Дата постановки</label>
                <input type="text" class="form-control" v-model="dateFrom"/>
                <small class="form-text text-muted">формат: YYYY-MM-DD</small>
              </div>

              <div class="form-group">
                <label>Дата снятия</label>
                <input type="text" class="form-control" v-model="dateTo"/>
                <small class="form-text text-muted">формат: YYYY-MM-DD</small>
              </div>

              <div class="form-group">
                <label>Комментарий</label>
                <textarea class="form-control" v-model="note"></textarea>
              </div>
            </form>

            <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-primary" @click="submitForm">
              {{ isAdd ? 'Добавить' : 'Обновить' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../../utils/formatDate';
import Select from '../../../common/Select';
import Flash from '../../../common/Flash';

export default {
  name: 'ClientConclusionDiagnosisForm',

  components: {Select, Flash},

  props: ['diagnoses', 'establishment'],

  data() {
    return {
      error: '',
      diagnosis: '',
      note: '',
      dateFrom: formatDate(new Date(), 'y-m-d'),
      dateTo: '',
    };
  },

  created() {
    if (typeof this.establishment !== 'undefined') {
      this.diagnosis = this.establishment.diagnosis;
      this.note = this.establishment.note;
      this.dateFrom = formatDate(this.establishment.dateFrom, 'y-m-d');

      if (this.establishment.dateTo instanceof Date) {
        this.dateTo = formatDate(this.establishment.dateTo, 'y-m-d');
      }
    }
  },

  computed: {
    isAdd() {
      return typeof this.establishment === 'undefined';
    },

    data() {
      return this.diagnoses.map(diagnosis => {
        return {
          label: diagnosis.title,
          value: diagnosis.id,
        };
      });
    },

    diagnosisTitle() {
      if (typeof this.establishment === 'undefined') {
        return '?';
      }

      const diagnosis = this.diagnoses.find(i => i.id === this.establishment.diagnosis);

      return typeof diagnosis !== 'undefined' ? diagnosis.title : '?';
    },
  },

  methods: {
    submitForm() {
      this.error = '';

      if (typeof this.diagnosis !== 'string' || this.diagnosis.trim() === '') {
        this.error = 'Диагноз не выбран';
      }

      if (typeof this.dateFrom !== 'string' || this.dateFrom.trim() === '') {
        this.error = 'Дата постановки не указана';
      }

      if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.dateFrom) !== true) {
        this.error = 'Дата постановки указана неправильно';
      }

      if (typeof this.dateTo === 'string' && this.dateTo.trim() !== '') {
        if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.dateTo) !== true) {
          this.error = 'Дата снятия указана неправильно';
        } else if (new Date(this.dateTo) < new Date(this.dateFrom)) {
          this.error = 'Дата снятия не может быть раньше даты постановки';
        }
      }

      if (this.error !== '') {
        return;
      }

      const data = {
        diagnosis: this.diagnosis,
        note: this.note,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      };

      if (typeof this.establishment !== 'undefined') {
        data.id = this.establishment.id;
      }

      this.$emit('submit', data);
    },
  },
};
</script>
